import { Box, Typography } from '@material-ui/core'
import moment from 'moment'

export const PouvoirAG = ({ details, pvagsConvocation }) => {
  return (
    <div
    // style={{
    //   pageBreakAfter: 'always',
    // }}
    >
      <Box style={{ fontSize: '12px', lineHeight: '2' }}>
        <Typography
          variant="h5"
          style={{
            fontWeight: 'normal',
            color: 'black',
          }}
        >
          <b>Pouvoir pour l'assemblée générale</b>
        </Typography>

        <div className="pdf-letter__header" style={{ maxWidth: '50%' }}>
          <Typography variant="body2">
            <b>
              Copropriété située au : {details?.adresse} - {details?.ville}{' '}
            </b>
            <Typography variant="body2"></Typography>
            <b>Copropriétaire : {details?.coproprietaire} </b>
          </Typography>
        </div>

        <div>
          <p style={{ textAlign: 'right' }}>
            {pvagsConvocation.ville} le{' '}
            {moment(pvagsConvocation.date).locale('fr').format('LL')}
          </p>
          <p>
            Je soussigné {details?.coproprietaire}, titulaire de{' '}
            {details?.tantiemes} tantièmes généraux, agissant en qualité de
            copropriétaire de la copropriété {pvagsConvocation.libelle} située{' '}
            {pvagsConvocation?.adresse}, {pvagsConvocation?.codepostal}{' '}
            {pvagsConvocation?.ville}, donne, par le présent, tous
            pouvoirs&sup1;
          </p>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              columnGap: '20px',
            }}
          >
            <p
              style={{
                borderBottom: '1px dotted black',
                fontWeight: 700,
                width: '100%',
                paddingBottom: '5px',
              }}
            >
              à:
            </p>
            <p
              style={{
                borderBottom: '1px dotted black',
                fontWeight: 700,
                width: '100%',
                paddingBottom: '5px',
              }}
            >
              ou à défaut à:
            </p>
          </div>
          <div style={{ marginBottom: '30px' }}>
            <p>À effet :</p>
            <ul>
              <li>
                D'assister à l'Assemblée Générale des Copropriétaires de
                l'immeuble ci-dessus indiqué, convoquée le{' '}
                {moment(details?.date).format('LLL')} selon les moyens et
                supports suivants :
                <ul>
                  <li>
                    <Typography variant="body2">
                      Accès : {details?.lieu}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2">
                      Vote par correspondance par formulaire à renvoyer; le
                      formulaire de vote doit être réceptionné au plus tard 3
                      jours francs avant la date de la réunion.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                De me représenter et exercer tous les droits que je tiens du
                règlement de Copropriété et de la loi ;
              </li>
              <li>
                De prendre part, en mon nom, à toutes délibérations, discussions
                et à tous votes, faire toutes protestations, oppositions,
                réserves ;
              </li>
              <li>
                D'accepter toutes fonctions et tous mandats, signer toute
                feuille de présence, ainsi que tous procès-verbaux de séance et
                tous actes relatifs à l'administration des parties communes ;
              </li>
              <li>
                De se substituer et généralement faire le nécessaire pour
                assurer ma représentation à la dite Assemblée Générale.
              </li>
            </ul>
            <p>
              Dans la mesure où je ne préciserais pas nommément de mandataire,
              mon pouvoir sera remis au Président de séance pour présider ladite
              Assemblée Générale avec la faculté pour lui de se substituer à
              toute personne de son choix. Ce mandat prendra effet donc après
              désignation du Président de séance. Sera retenu comme pouvoir la
              dernière personne ayant reçu mon pouvoir.
            </p>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <p
                  style={{
                    borderBottom: '1px dotted black',
                    marginBottom: '2px',
                    paddingBottom: '5px',
                    fontWeight: 700,
                  }}
                >
                  Signature du mandant
                </p>
                <span style={{ fontSize: '10px' }}>
                  Dater, signer et mettre de sa main la mention{' '}
                </span>
                <span>"BON POUR POUVOIR"</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <p
                  style={{
                    borderBottom: '1px dotted black',
                    marginBottom: '2px',
                    paddingBottom: '5px',
                    fontWeight: 700,
                  }}
                >
                  Signature du mandataire
                </p>
                <span style={{ fontSize: '10px' }}>
                  Dater, signer et mettre de sa main la mention{' '}
                </span>
                <span>"BON POUR ACCEPTATION"</span>
              </div>
            </div>
          </div>
          <p style={{ fontSize: '10px', lineHeight: 1 }}>
            <b>&sup1; Rappel Art. 22 de la Loi n° 65-557 du 10 juillet 1965</b>{' '}
            : Une même personne pourra recevoir plus de trois mandats de vote si
            le total des voix dont elle dispose n'excède pas 10% de la totalité
            des voix du Syndicat. Chacun des époux copropriétaires communs ou
            indivis d'un lot peut recevoir personnellement des délégations de
            vote. Tout mandataire désigné peut subdéléguer son mandat à une
            autre personne, à condition que cela ne soit pas interdit par le
            mandat. Lorsque le syndic a reçu des mandats sans indication de
            mandataire, il ne peut ni les conserver pour voter en son nom, ni
            les distribuer lui-même aux mandataires qu'il choisit. Ne peuvent ni
            recevoir de mandat pour représenter un copropriétaire, ni présider
            l'assemblée générale : 1° Le syndic, son conjoint, le partenaire lié
            à lui par un pacte civil de solidarité, son concubin ; 2° Les
            ascendants et descendants du syndic ainsi que ceux de son conjoint
            ou du partenaire lié à lui par un pacte civil de solidarité ou de
            son concubin ; 3° Les préposés du syndic, leur conjoint, le
            partenaire lié à eux par un pacte civil de solidarité, leur concubin
            ; 4° Les ascendants et descendants des préposés du syndic ainsi que
            ceux de leur conjoint ou du partenaire lié à eux par un pacte civil
            de solidarité ou de leur concubin. Ordonnance n° 2020-1400 du 18
            novembre 2020, Art.8 30: Par dérogation aux dispositions de
            l'article 22 [...] de la loi du 10 juillet 1965 susvisée, et jusqu'à
            un mois après la fin de l'état d'urgence sanitaire déclaré par le
            décret n° 2020-1257 du 14 octobre 2020 déclarant l'état d'urgence
            sanitaire, prorogé dans les conditions prévues à l'article L.
            3131-13 du code de la santé publique, un mandataire peut recevoir
            plus de trois délégations de vote si le total des voix dont il
            dispose lui-même et de celles de ses mandants n'excède pas 15 % des
            voix du syndicat des copropriétaires.
          </p>
        </div>
      </Box>
    </div>
  )
}
